// German for NetworkPage.tsx (docs/R5-NETWORK-DESIGN.md). Keys already carried by
// `i18n/common.de.ts`, `NetworkZone.de.ts` and `FlowMatrix.de.ts` (this page imports both
// components, so their catalogues are registered) are not repeated here.
import { registerDe } from '../i18n/index.js';

registerDe({
  'Who works with whom': 'Wer mit wem arbeitet',
  'payers': 'Kostenträger',
  'providers': 'Anbieter',
  'links': 'Verknüpfungen',
  'latest year': 'letztes Jahr',
  'Which organisations work with which, and how many people from which institution are placed where.':
    'Welche Organisationen mit welchen arbeiten, und wie viele Personen welcher Stelle wo platziert sind.',
  'Proposed links in Review': 'Vorgeschlagene Verknüpfungen in der Prüfung',

  'Matrix': 'Matrix',
  'Canton': 'Kanton',
  'Sub-sector': 'Teilbereich',
  'held only': 'nur übernommen',
  'by regime': 'nach Regime',
  'Clear filters': 'Filter zurücksetzen',
  'Find an organisation to focus…': 'Eine Organisation zum Fokussieren suchen…',
  'nothing to filter by yet': 'noch nichts zum Filtern',
  'Sort by this column': 'Nach dieser Spalte sortieren',

  'Payers': 'Kostenträger',
  '{b} bodies · {r} regimes · {o} residual': '{b} Stellen · {r} Regime · {o} Rest',
  '{n} of {m} providers give a count': '{n} von {m} Anbietern nennen eine Zahl',
  'of {m} payers · the coverage bars’ denominator': 'von {m} Kostenträgern · der Nenner der Abdeckungsbalken',
  'no payer holds a channel volume yet': 'noch kein Kostenträger führt ein Kanalvolumen',
  'channel.measure_participants — people who received at least one insertion or training measure in the year, read on the payer body itself':
    'channel.measure_participants — Personen mit mindestens einer Eingliederungs- oder Bildungsmassnahme im Jahr, auf der Kostenträgerstelle selbst gelesen',
  'no payer holds channel.measure_participants yet — the coverage column appears once a run reads one':
    'noch kein Kostenträger führt channel.measure_participants — die Abdeckungsspalte erscheint, sobald ein Auftrag einen Wert liest',
  'payer, referrer and funder counterparts': 'Kostenträger-, Zuweiser- und Geldgeber-Gegenparteien',
  'Providers': 'Anbieter',
  'of {total} organisations on the record': 'von {total} erfassten Organisationen',
  'organisations naming a link': 'Organisationen mit einer Verknüpfung',
  'Links held': 'Übernommene Verknüpfungen',
  '{p} proposed': '{p} vorgeschlagen',
  'nothing waiting in review': 'nichts wartet in der Prüfung',
  'People accounted': 'Erfasste Personen',
  'a named payer accounts for them · {n} of {m} providers give a count': 'ein genannter Kostenträger steht für sie · {n} von {m} Anbietern nennen eine Zahl',
  'participants a named payer accounts for': 'Teilnehmende, für die ein genannter Kostenträger steht',
  'Σ over payers of the people their named providers account for — computed, carries no mark':
    'Σ über die Kostenträger der Personen, für die ihre genannten Anbieter stehen — berechnet, ohne Anspruchszeichen',
  'Channel volumes': 'Kanalvolumen',
  'of {m} payers hold a channel.measure_participants reading — the coverage bars’ denominator':
    'von {m} Kostenträgern führen einen Wert channel.measure_participants — der Nenner der Abdeckungsbalken',
  'no payer holds channel.measure_participants yet — the coverage bars have no denominator':
    'noch kein Kostenträger führt channel.measure_participants — die Abdeckungsbalken haben keinen Nenner',

  'Focus': 'Fokus',
  'Neighbourhood': 'Umfeld',
  'this organisation and its links only; a square is a payer body; dashed is proposed, dotted is estimated; the figure is the source’s own':
    'nur diese Organisation und ihre Verknüpfungen; ein Quadrat ist eine Kostenträgerstelle; gestrichelt ist vorgeschlagen, gepunktet geschätzt; die Zahl ist die der Quelle',

  'The network could not be read: {error}': 'Das Netzwerk konnte nicht gelesen werden: {error}',
  'No link matches these filters. Clear one to widen the slice.': 'Keine Verknüpfung passt zu diesen Filtern. Einen zurücksetzen, um den Ausschnitt zu weiten.',
  'No link is on the record yet. A research run files the payers, mandants and federations an organisation’s pages name; an operator declares one from an organisation’s Network zone.':
    'Es ist noch keine Verknüpfung erfasst. Ein Rechercheauftrag erfasst die Kostenträger, Auftraggeber und Verbände, die die Seiten einer Organisation nennen; ein Operator erklärt eine in der Netzwerk-Zone einer Organisation.',

  'who pays for whom: a bar is a length on a zero baseline; the dotted rest is the channel’s volume nobody has accounted for':
    'wer für wen zahlt: ein Balken ist eine Länge ab Nullbasis; der gepunktete Rest ist das Kanalvolumen, für das niemand steht',
  'Σ within': 'Σ innerhalb',
  'each Σ within the payer’s own latest year': 'jede Σ innerhalb des jeweils letzten Jahres des Kostenträgers',
  'Payer': 'Kostenträger',
  'Coverage of the channel’s volume': 'Abdeckung des Kanalvolumens',
  'Places': 'Plätze',
  'CHF': 'CHF',
  '{n} bodies folded': '{n} Stellen zusammengefasst',
  'residual line': 'Restzeile',
  '{n} give a count': '{n} nennen eine Zahl',
  'of': 'von',
  'none of {m} accounted': 'keine von {m} erfasst',
  'volume not collected': 'Volumen nicht erhoben',
  'the channel counts {m} people in a measure ({when}); no provider gives a count yet':
    'der Kanal zählt {m} Personen in einer Massnahme ({when}); noch kein Anbieter nennt eine Zahl',
  'this body holds no channel.measure_participants cell — the bar has no denominator until a run reads one':
    'diese Stelle führt keine Zelle channel.measure_participants — der Balken hat keinen Nenner, bis ein Auftrag einen liest',
  '{n} of {m} payers hold a channel volume': '{n} von {m} Kostenträgern führen ein Kanalvolumen',
  'a percentage is never summed across organisations; places and CHF are Σ within one year':
    'ein Prozentsatz wird nie über Organisationen summiert; Plätze und CHF sind Σ innerhalb eines Jahres',
  'Other counterparts': 'Weitere Gegenparteien',
  'umbrellas, partners, accreditors, vendors, consultants, auditors — relations without a flow of people or money':
    'Dachverbände, Partner, Bewilligungsbehörden, Lieferanten, Berater, Revisionsstellen — Beziehungen ohne Personen- oder Geldfluss',

  'one row per organisation naming a link; the mix is a 100 % stacked bar of its participants (or revenue) by payer, largest first, the dotted rest unattributed':
    'eine Zeile pro Organisation mit einer Verknüpfung; der Mix ist ein 100-%-Stapelbalken ihrer Teilnehmenden (oder Erträge) nach Kostenträger, grösste zuerst, der gepunktete Rest nicht zugeordnet',
  'Payers named': 'Genannte Kostenträger',
  'Clients per year': 'Klientinnen und Klienten pro Jahr',
  'no mix on the record': 'kein Mix erfasst',
  '{n} amounts read, no same-year revenue to divide by': '{n} Beträge gelesen, kein Ertrag desselben Jahres zum Teilen',
  'of participants': 'der Teilnehmenden',
  '{name}: {basis}, {year} — {n} payers named, {a} % attributed, the dotted rest unattributed':
    '{name}: {basis}, {year} — {n} Kostenträger genannt, {a} % zugeordnet, der gepunktete Rest nicht zugeordnet',
  'the mix does not sum to 100': 'der Mix summiert nicht auf 100',
  'as of': 'per',

  'providers down, payers across; a cell’s ink is the share of the provider’s participants the payer accounts for, a figure is a count or an amount, ▪ a relation with no figure, ◇ a proposal':
    'Anbieter nach unten, Kostenträger quer; die Tinte einer Zelle ist der Anteil der Teilnehmenden des Anbieters, für den der Kostenträger steht, eine Zahl ist eine Anzahl oder ein Betrag, ▪ eine Beziehung ohne Zahl, ◇ ein Vorschlag',
  "realised; the budget row is on the organisation's page": 'Rechnung; die Budgetzeile steht auf der Seite der Organisation',
}, 'NetworkPage');
